import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  numberWithCommas,
} from 'common/formatters';

import {
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import {
  SR_API_ACTION_ADMIN_UPDATE_ITEM,
} from 'api/actionTypes';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';
import SrTable from 'client/components/SrTable';
import SrFormikField, {
  SR_FIELD_THEME_ADMIN_HORIZONTAL_SMALL,
} from 'client/components/SrFormikField';

import postWithState from 'client/actions/postWithState';

function getFloorPlanFormFields({ floorPlans, listings }) {
  const floorPlanChoices = floorPlans.map((floorPlan) => ({
    label: floorPlan.displayName,
    value: floorPlan.id,
  }));

  return listings.map((listing) => ({
    id: `${listing.id}`,
    type: 'select',
    properties: {
      choices: floorPlanChoices,
    },
  }));
}

class SrTableApartmentListingsWithoutFloorPlan extends Component {
  static propTypes = {
    listings: PropTypes.array.isRequired,
    floorPlans: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  }

  _onSubmitForm = async (formValues, formikBag) => {
    const { dispatch, onChange } = this.props;

    const listingsByFloorPlanToUpdate = Object.keys(formValues)
      .filter((listingId) => formValues[listingId])
      .reduce((memo, listingId) => {
        const floorPlanId = formValues[listingId];
        memo[floorPlanId] = memo[floorPlanId] || [];
        memo[floorPlanId].push(parseInt(listingId, 10));
        return memo;
      }, {});

    for (const floorPlanId of Object.keys(listingsByFloorPlanToUpdate)) {
      await dispatch(postWithState, {
        action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
        payload: {
          table: 'listings',
          whereIn: ['id', listingsByFloorPlanToUpdate[floorPlanId]],
          updates: {
            floorPlanId: parseInt(floorPlanId, 10),
          },
        },
      });
    }

    formikBag.resetForm();
    onChange();
  }

  render() {
    const { listings, floorPlans } = this.props;

    const formFields = getFloorPlanFormFields({ floorPlans, listings });

    return (
      <Formik
        initialValues={createInitialValues({
          formFields: formFields,
        })}
        validate={createFormValidationFn(formFields)}
        onSubmit={this._onSubmitForm}
        render={(formikBag) => (
          <Form autoComplete='off'>
            <SrFlex justify='between' marginBottom={10}>
              <SrText size='xl' font='whitney-sc' color={listings.length ? 'red' : null}>
                units without floorplans
              </SrText>
            </SrFlex>
            <SrTable
              headers={[
                { content: 'unit' },
                { content: 'beds' },
                { content: 'baths' },
                { content: 'square feet' },
                { content: 'price' },
                { content: 'floor plan', width: 15 },
              ]}
              rows={listings.map((listing) => ({
                cells: [
                  {
                    content: (
                      <SrLink color='blue300' target='_blank' to={`/admin/listings/edit/${listing.id}`}>
                        {listing.apartmentUnit}
                      </SrLink>
                    ),
                  },
                  { content: listing.bedrooms },
                  { content: listing.bathrooms },
                  { content: numberWithCommas(listing.squareFeet) },
                  { content: `$${numberWithCommas(listing.price)}` },
                  {
                    content: (
                      <SrFormikField
                        key={`${listing.id}`}
                        formField={formFields.find((formField) => formField.id === `${listing.id}`)}
                        formikBag={formikBag}
                        className={SR_FIELD_THEME_ADMIN_HORIZONTAL_SMALL}
                      />
                    ),
                  },
                ],
              }))}
            />
            {listings.length > 0 && (
              <SrBox marginTop={20}>
                <ButtonDeprecated
                  type='submit'
                  disabled={!formikBag.isValid}
                >
                  save
                </ButtonDeprecated>
              </SrBox>
            )}
          </Form>
        )}
      />
    );
  }
}

SrTableApartmentListingsWithoutFloorPlan.displayName = 'SrTableApartmentListingsWithoutFloorPlan';

export default SrTableApartmentListingsWithoutFloorPlan;
